<div class="side-navbar" style="margin-top: 40px;">
    <ul class="nav nav-pills flex-column mb-auto">
        <li class="nav-item">
            <a class="nav-link" routerLinkActive="active" aria-current="page" routerLink="/dashboard/buyer/dashboard">
                <i class="fa-solid fa-house"></i>
                <span class="label-menu">{{ 'sidebar.dashboard' | translate }}</span>
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/buyer/edit-profile">
                <i class="fa-solid fa-user"></i>
                <span class="label-menu">{{ 'sidebar.profile' | translate }}</span>
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/buyer/my-bids">
                <i class="fa-solid fa-gavel"></i>
                <span class="label-menu">{{ 'sidebar.my-bids' | translate }}</span>
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/buyer/won-vehicles">
                <i class="fa-solid fa-trophy"></i>
                <span class="label-menu">{{ 'sidebar.won-vehicles' | translate }}</span>
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/buyer/watchlist">
                <i class="fa-regular fa-bookmark"></i>
                <span class="label-menu">{{ 'sidebar.watchlist' | translate }}</span>
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/buyer/order-history">
                <i class="fa-solid fa-clock-rotate-left"></i>
                <span class="label-menu">{{ 'sidebar.deposit' | translate }}</span>
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/buyer/transaction">
                <i class="fa-solid fa-wallet"></i>
                <span class="label-menu">{{ 'sidebar.payment' | translate }}</span>
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/buyer/history">
                <i class="fa-solid fa-clock-rotate-left"></i>
                <span class="label-menu">{{ 'sidebar.history-&-gatepass' | translate }}</span>
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/buyer/statement">
                <i class="fa-solid fa-receipt"></i>
                <span class="label-menu">{{ 'sidebar.statement' | translate }}</span>
            </a>
        </li>
        <li>
            <a class="nav-link" routerLinkActive="active" routerLink="/dashboard/buyer/user-queries">
                <i class="fa-regular fa-circle-question"></i>
                <span class="label-menu">{{ 'sidebar.tickets' | translate }}</span>
            </a>
        </li>
    </ul>
</div>
